import variables from '@/style/variables.scss'
import variablesMe from '@/style/variables-me.scss'

const env = process.env.VUE_APP_ENV || 'development'
const scssVariables = ['stableMe', 'stableSa', 'productionMe', 'productionSa'].includes(env) ? variablesMe : variables
export default scssVariables
